module.exports = __webpack_public_path__ + "static/media/Group1000002708.a5703d32.svg";